import {
  User,
  Briefcase,
  FolderKanban,
  Mail,
  FileText,
  Gamepad2,
  Keyboard
} from 'lucide-react';

export const BOOT_MESSAGES = [
  'FOREST OS v3.14.159',
  'Copyright (c) 2025 Ossama Industries',
  '',
  'Starting problem-solving engine... OK',
  'Loading personality modules... OK',
  'Mounting /dev/ambition... OK',
  'Checking gym schedule... 6AM (non-negotiable)',
  'Loading soccer instincts... OK',
  'Importing nature appreciation... OK',
  'Syncing coffee.dependency... LOW (survivable)',
  '',
  'All systems nominal.',
  'Ready when you are.'
];

export const SKILLS = [
  'TypeScript', 'React', 'Python', 'C++', 'Java',
  'Ruby', 'AWS', 'Docker', 'PostgreSQL', 'Node.js'
];

export const FACTS = [
  "I turn coffee into code (and occasionally bugs)",
  "Soccer enthusiast who believes debugging is just tactical analysis",
  "Nature lover - trees don't have merge conflicts",
  "Lifting weights to compensate for imposter syndrome",
  "I've mass-produced Notion templates",
  "Probably refactoring something right now"
];

export const STICKY_NOTES = [
  { title: "TODO", content: "Ship code\nDrink water\nTouch grass" },
  { title: "Note to self", content: "The bug is always where you least expect it" },
  { title: "Reminder", content: "6AM gym\n9AM standup\n∞ coffee" },
  { title: "Philosophy", content: "If it works, don't touch it.\n\n...okay maybe refactor a little" },
  { title: "Current mood", content: "Somewhere between\n'it works!'\nand 'why does it work?'" },
];

export const SHORTCUTS_NOTE = {
  title: "SHORTCUTS",
  content: "⌘/Ctrl + 1  About\n⌘/Ctrl + 2  Experience\n⌘/Ctrl + 3  Projects\n⌘/Ctrl + 4  Contact"
};

export const STATUSES = [
  { label: "Status", value: "Building something cool" },
  { label: "Last commit", value: '"fixed bug" (x47)' },
  { label: "Coffee level", value: "Dangerously low" },
  { label: "Dream", value: "Build something impactful" },
  { label: "Current quest", value: "Building in stealth" },
  { label: "Tip", value: "Press Ctrl/Cmd + 1-6" },
];

export const ERROR_MESSAGES = [
  "Warning: Excessive talent detected",
  "Error 418: I'm a teapot",
  "Alert: You've been here a while. Hire me?",
  "Notice: Coffee levels critically low",
  "Warning: Sarcasm module overloaded"
];

export const TYPING_COMMANDS = [
  'sudo rm -rf bugs/',
  'git push origin main',
  'npm install success',
  'docker compose up',
  'ssh user@server.com',
  'curl api.hire.me',
  'vim ~/.bashrc',
  'chmod +x deploy.sh',
  'grep -r "talent"',
  'make coffee --strong'
];

// Icon components for reuse
export const ICONS = {
  about: User,
  experience: Briefcase,
  projects: FolderKanban,
  contact: Mail,
  resume: FileText,
  snake: Gamepad2,
  typing: Keyboard
};

export const DESKTOP_ICONS = [
  { id: 'about', Icon: User, label: 'About Me', style: { left: 30, top: 30 } },
  { id: 'experience', Icon: Briefcase, label: 'Experience', style: { left: 130, top: 60 } },
  { id: 'projects', Icon: FolderKanban, label: 'Projects', style: { left: 40, top: 150 } },
  { id: 'contact', Icon: Mail, label: 'Contact', style: { left: 150, top: 180 } },
  { id: 'resume', Icon: FileText, label: 'Resume.pdf', style: { left: 50, top: 280 } },
  { id: 'snake', Icon: Gamepad2, label: 'Snake', style: { left: 150, top: 310 } },
  { id: 'typing', Icon: Keyboard, label: 'TypeSpeed', style: { left: 60, top: 400 } },
];

export const PROFILE = {
  name: 'OSSAMA ELHELALI',
  title: 'CS @ UWaterloo | Software Engineer',
  location: 'Waterloo, ON',
  email: 'oelhelal@uwaterloo.ca',
  linkedin: 'https://linkedin.com/in/ossamaelhelali',
  github: 'https://github.com/Ossama-E',
  bio: "Hey! I'm a CS student at UWaterloo who loves building things that matter. When I'm not shipping code or squashing bugs, you'll find me on hiking trails, the soccer field, or at the gym."
};
